// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0d3f696f","455":"a5ad0854","977":"c0506d4e"}[chunkId] + ".chunk.js";
};